import { IPriceOrderParams } from 'hooks/price-order/types';
import { IPriceOrderDeliveryInput } from 'remote/queries/order';
import { UserDetails } from 'state/auth/hooks/use-current-user';
import { ServiceMode } from 'state/order';

export const buildPriceDeliveryInput = (
  order: Pick<
    IPriceOrderParams,
    'deliveryAddress' | 'deliveryPhoneNumber' | 'serviceMode' | 'tipCents' | 'deliveryInstructions'
  >,
  user: UserDetails,
  enableSimpleDelivery = false
): IPriceOrderDeliveryInput | null => {
  if (order.serviceMode !== ServiceMode.DELIVERY || !order.deliveryAddress) {
    return null;
  }

  return {
    dropoff: {
      ...order.deliveryAddress,
      phoneNumber: order.deliveryPhoneNumber || user.details.phoneNumber
    },
    instructions: enableSimpleDelivery ? order.deliveryInstructions : undefined,
    tipCents: order.tipCents
  };
};
